// Breadcrumb detay etiketi (Finar rev-A 15) — sayfa, iç içe yolun son parçası için "Detay"
// yerine kendi adını verir (ör. müşteri detayında müşteri adı). Etiket yol ile birlikte tutulur;
// AppShell yalnız geçerli yolla eşleşen etiketi kullanır (sayfa değişince bayat ad görünmez).
import { create } from "zustand";

export interface BreadcrumbDetail {
  path: string;
  label: string;
}

interface BreadcrumbState {
  detail: BreadcrumbDetail | null;
  setDetail: (path: string, label: string) => void;
  clearDetail: (path: string) => void;
}

export const useBreadcrumbStore = create<BreadcrumbState>((set, get) => ({
  detail: null,
  setDetail: (path, label) => set({ detail: { path, label } }),
  clearDetail: (path) => {
    if (get().detail?.path === path) set({ detail: null });
  },
}));
